import AbstractProvidedClass from "../../shared/AbstractProvidedClass";

export default class RectangleVerticalBorder extends AbstractProvidedClass {
    defaultTolerance = this.mobile ? 12 : 7;

    constructor(provider, parent, corner1, corner2) {
        super(provider);
        this.parent = parent;
        this.corner1 = corner1;
        this.corner2 = corner2;
    }

    setOpposite(border) {
        this.opposite = border;
    }

    hovered(viewX, viewY) {
        return this.currentMinX <= viewX
            && this.currentMaxX >= viewX
            && this.currentMinY <= viewY
            && this.currentMaxY >= viewY;
    }

    drag() {
        this.updatePositions();
        this.updateParent();
    }

    updatePositions() {
        let absdX;
        if (this.parent.rotation == 0) {
            // No rotation
            // Mouse X minus the actual X of the border
            absdX = this.view.snappedAbsX - (this.parent.center.absX + this.corner1.absX);
        } else if (Math.abs(this.parent.rotation) == this.p.PI) {
            // Half rotation
            // Calculating the border X by taking the center minus the the corner X because it's flipped
            absdX = (this.parent.center.absX - this.corner1.absX) - this.view.snappedAbsX;
        } else if (this.parent.rotation == -this.p.HALF_PI) {
            // Quarter rotation back
            // Because of quarter turn the border is actually on the Y-axis. So we calculate from the Y coordinates of the mouse and center. But the border distance is still on the X-axis relative to the rotation.
            absdX = (this.parent.center.absY - this.corner1.absX) - this.view.snappedAbsY;
        } else if (this.parent.rotation == this.p.HALF_PI) {
            // Quarter rotation forward
            absdX = this.view.snappedAbsY - (this.parent.center.absY + this.corner1.absX);
        } else {
            // Custom rotation
            let [viewX] = this.view.getRelative(this.parent.center.currentX, this.parent.center.currentY, this.parent.rotation); // Relative xPosition of the mouse to the center of the element

            let absX = viewX / this.view.scale; // Raw xPosition of the mouse in the image
            absdX = (absX - this.corner1.absX); // The difference between the mouse position and the border position
        }
        this.corner1.absX += absdX; // Move the border
        this.corner2.absX += absdX; // Move the border
        let avgX = (this.corner1.absX + this.opposite.corner1.absX) / 2; // The average xPosition of the two borders (the new center of the element)

        // Update the center of the element
        this.parent.absX += avgX * Math.cos(this.parent.rotation);
        this.parent.absY += avgX * Math.sin(this.parent.rotation);
    }

    updateParent() {
        // Update the corners with the new relative positions
        this.parent.updateCorners();

        this.parent.row.updateImg();
        this.getTab('info').input.width.value(this.calculatePixelToDisplayDistance(this.parent.width));
    }

    mouseOver(viewX, viewY) {
        if (!this.hovered(viewX, viewY)) {
            return false;
        }

        this.cursor.resizeHorizontal(this.parent.rotation);
        return true;
    }

    get absX() {
        return this.corner1.absX;
    }

    get currentMinX() {
        return this.corner1.currentX - this.tolerance;
    }

    get currentMaxX() {
        return this.corner1.currentX + this.tolerance;
    }

    get currentMinY() {
        return Math.min(this.corner1.currentY, this.corner2.currentY);
    }

    get currentMaxY() {
        return Math.max(this.corner1.currentY, this.corner2.currentY);
    }

    get tolerance() {
        return Math.min(this.defaultTolerance, this.parent.currentWidth / 10)
    }
}
